<template>
    <div>
        <main-layout-content :breadcrumbs="pageBreadcrumbs">
            <template #content>
                <component
                    :is="$auth.isSubdomainActive() ? 'div' : 'common-page-plain'"
                    :padding="$auth.isSubdomainActive() ? '' : 'tiny'"
                >
                    <div class="contact">
                        <div class="contact__info">
                            <common-content-spacer height="medium">
                                <div class="contact__info--heading">
                                    <span>{{ $t('pages.contact.contact.description_1') }}</span>
                                </div>

                                <div class="contact__info--heading--text">
                                    <common-content-spacer height="small">
                                        <p>{{ $t('pages.contact.contact.description_2') }}</p>
                                    </common-content-spacer>
                                </div>

                                <div class="contact__info--company">
                                    <common-content-spacer height="medium">
                                        <div class="contact__info--heading">
                                            <span>{{ $t('pages.contact.contact.contact_us') }}</span>
                                        </div>
                                        <div class="contact__info--heading--text">
                                            <common-content-spacer height="small">
                                                <p>{{ $t('pages.contact.contact.description_3') }}</p>
                                            </common-content-spacer>
                                        </div>
                                        <div class="contact__info--company--wrapper">
                                            <div v-if="$auth.isSubdomainActive()" class="contact__info--company--phone">
                                                <common-icon name="phone" size="gigantic"></common-icon>
                                                <div>
                                                    <p>
                                                        <span class="contact__info--company--phone--text">
                                                            {{ $t('pages.contact.contact.phone') }}:
                                                        </span>
                                                        <span
                                                            v-if="!isPhoneShow"
                                                            class="contact__info--company--phone--link"
                                                            @click="showPhone"
                                                        >
                                                            {{ $t('components.user.user_card.click_phone') }}
                                                        </span>
                                                        <span v-else class="contact__info--company--phone--link">
                                                            <a :href="`tel:${getPhone}`" target="_blank">{{ getPhone }}</a>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="contact__info--company--phone">
                                                <common-icon name="email" size="gigantic"></common-icon>
                                                <div>
                                                    <p>
                                                        <span class="contact__info--company--phone--text">
                                                            {{ $t('pages.contact.contact.email') }}:
                                                        </span>
                                                        <span
                                                            v-if="!isEmailShow"
                                                            class="contact__info--company--phone--link"
                                                            @click="showEmail"
                                                        >
                                                            {{ $t('components.user.user_card.click_email') }}
                                                        </span>
                                                        <span v-else class="contact__info--company--phone--link">
                                                            <a :href="`mailto:${getEmail}`" target="_blank">{{ getEmail }}</a>
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div v-if="$auth.isSubdomainActive()" class="contact__info--company--phone">
                                                <common-icon name="location-point" size="gigantic"></common-icon>
                                                <div>
                                                    <p>
                                                        <span class="contact__info--company--phone--text">
                                                            {{ $t('pages.contact.contact.address') }}:
                                                        </span>
                                                        <span class="contact__info--company--phone--link" @click="openMap()">
                                                            {{ getAddress }}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </common-content-spacer>
                                </div>

                                <div class="contact__info--social">
                                    <div
                                        v-if="getFacebook"
                                        class="contact__info--social-item contact__info--social-item--facebook"
                                    >
                                        <a :href="getFacebook" target="_blank">
                                            <common-icon name="facebook" size="extra-huge"></common-icon>
                                        </a>
                                    </div>
                                    <div
                                        v-if="getInstagram"
                                        class="contact__info--social-item contact__info--social-item--instagram"
                                    >
                                        <a :href="getInstagram" target="_blank">
                                            <common-icon name="instagram" size="extra-huge"></common-icon>
                                        </a>
                                    </div>
                                    <div v-if="getTwitter" class="contact__info--social-item contact__info--social-item--twitter">
                                        <a :href="getTwitter" target="_blank">
                                            <common-icon name="x-twitter" size="extra-huge"></common-icon>
                                        </a>
                                    </div>
                                    <div v-if="getTikTok" class="contact__info--social-item contact__info--social-item--tiktok">
                                        <a :href="getTikTok" target="_blank">
                                            <common-icon name="tiktok" size="extra-huge"></common-icon>
                                        </a>
                                    </div>

                                    <div v-if="getLinkedIn" class="contact__info--social-item contact__info--social-item--tiktok">
                                        <a :href="getLinkedIn" target="_blank">
                                            <common-icon name="linkedin" size="extra-huge"></common-icon>
                                        </a>
                                    </div>

                                    <div v-if="getYoutube" class="contact__info--social-item contact__info--social-item--tiktok">
                                        <a :href="getYoutube" target="_blank">
                                            <common-icon name="youtube" size="extra-huge"></common-icon>
                                        </a>
                                    </div>

                                    <div v-if="getPromo" class="contact__info--social-item contact__info--social-item--tiktok">
                                        <a :href="getPromo" target="_blank">
                                            <common-icon name="web" size="extra-huge"></common-icon>
                                        </a>
                                    </div>
                                </div>
                            </common-content-spacer>
                        </div>
                        <div class="contact__form">
                            <div class="contact__form--container">
                                <common-content-spacer height="medium">
                                    <common-page-header :heading="$t('pages.contact.contact.heading')"></common-page-header>
                                    <contact-form></contact-form>
                                </common-content-spacer>
                            </div>
                        </div>
                    </div>
                </component>
            </template>
        </main-layout-content>
    </div>
</template>

<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import RoutesEnum from 'enums/routes.enum'
    import ContactForm from 'components/forms/contact/ContactForm'
    import Store from '~/store'

    export default {
        components: { MainLayoutContent, ContactForm },

        data() {
            return {
                tabs: [],
                contactImage: require('../../assets/images/contact-us.png'),
                company: null,
                isEmailShow: false,
                isPhoneShow: false,
            }
        },

        computed: {
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.contact.contact.breadcrumbs.home'),
                        route: { name: RoutesEnum.INDEX.HOME },
                    },
                    {
                        label: this.$t('pages.contact.contact.breadcrumbs.contact'),
                    },
                ]
            },

            getAddress() {
                return `${this.company?.locationsForCompany[0].address}, ${this.company?.locationsForCompany[0].city.name}`
            },

            getPhone() {
                return `${this.company?.locationsForCompany[0].telephones[0].telephone}`
            },

            getEmail() {
                if (this.$auth.isSubdomainActive()) {
                    return `${this.company?.locationsForCompany[0].emails[0].email}`
                }
                return process.env.VUE_APP_EMAIL
            },

            getFacebook() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.facebook
                }
                return process.env.VUE_APP_FACEBOOK
            },

            getInstagram() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.instagram
                }
                return process.env.VUE_APP_INSTAGRAM
            },

            getLinkedIn() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.linkedIn
                }
                return process.env.VUE_APP_LINKEDIN
            },

            getTwitter() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.twitter
                }
                return process.env.VUE_APP_TWITTER
            },

            getTikTok() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.tiktok
                }
                return process.env.VUE_APP_TIKTOK
            },

            getYoutube() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.youtube
                }
                return process.env.VUE_APP_YOUTUBE
            },

            getPromo() {
                if (this.$auth.isSubdomainActive()) {
                    return this.company?.webpromo
                }
                return process.env.VUE_APP_WEB_PROMO
            },
        },

        methods: {
            openMap() {
                window.open(
                    `https://www.google.com/maps/search/?api=1&query=${this.company?.locationsForCompany[0].latitude},${this.company?.locationsForCompany[0].longitude}`,
                    '_blank',
                )
            },

            showEmail() {
                this.isEmailShow = true
            },

            showPhone() {
                this.isPhoneShow = true
            },
        },

        mounted() {
            if (this.$auth.isSubdomainActive()) {
                this.company = Store.getters['data/getSubdomainCompany']
            }
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .page-plain {
        margin-left: 15px;
        margin-right: 15px;
        @include breakpoint(tablet) {
            padding: 5px;
        }
    }

    .contact {
        @include breakpoint(smartphone-large) {
            border-radius: 30px;
            padding: 20px;
            background-color: $color--bg-dashboard;
        }
        display: flex;
        flex-wrap: wrap;
        padding: 50px;
        justify-content: center;

        &__info {
            width: 50%;
            min-width: 400px;
            padding: 50px;

            @include breakpoint(tablet) {
                width: 100%;
                padding: 0;
                border-right: none;
            }

            @include breakpoint(smartphone-large) {
                min-width: 270px;
            }

            &--heading {
                display: flex;
                align-items: center;
                flex-direction: row;

                span {
                    font-size: 24px;
                    font-weight: 700;
                    color: $color--txt-header;
                    display: inline-block;
                    width: auto;
                    justify-self: stretch;
                    padding-right: 30px;
                }

                &--text {
                    font-size: 17px;
                    color: $color--txt-header;
                }
            }

            &--social {
                width: 100%;
                display: flex;
                &-item {
                    margin-right: 10px;

                    &--facebook {
                        color: $color-blue--facebook;
                    }

                    &--instagram {
                        color: $color-blue--instagram;
                    }

                    &--twitter {
                        color: $subdomain-medium1;
                    }
                }
            }

            &--company {
                &--phone {
                    display: flex;
                    align-items: center;
                    flex-wrap: nowrap;

                    &--text {
                        font-weight: 600;
                        display: inline-block;
                        margin-right: 5px;
                        word-break: break-word;
                    }

                    &--link {
                        color: $color-link;
                        cursor: pointer;
                        word-break: break-word;

                        &:hover {
                            opacity: 0.7;
                        }
                    }

                    .icon {
                        margin-right: 10px;
                        min-width: 50px;
                    }
                }
            }
        }

        &__form {
            min-width: 400px;
            width: 50%;

            &--container {
                @include breakpoint(tablet) {
                    padding: 20px;
                }
                background-color: $color--bg-dashboard;
                border-radius: 30px;
                padding: 50px 40px 40px 40px;
            }

            @include breakpoint(tablet) {
                width: 100%;
                padding-left: 0;
                margin-top: 50px;
            }

            @include breakpoint(smartphone-large) {
                min-width: 270px;
            }
        }
    }

    .subdomain-layout {
        .contact {
            background: $color--bg-dashboard;
            border-radius: 20px;
            &__info {
                &--company {
                    &--phone {
                        &--link {
                            color: $color-link;
                        }
                    }
                }
            }

            &__form {
                &--container {
                    background-color: $color-white;
                }
            }
        }

        &--navy_black,
        &--black {
            .contact {
                background-color: $subdomain-black2;

                &__info {
                    &--heading {
                        span {
                            color: $color-white;
                        }

                        &--text {
                            color: $subdomain-light;
                            font-size: 16px;
                        }
                    }

                    &--company {
                        &--phone {
                            &--text {
                                color: $color-white;
                            }

                            .icon {
                                color: $color-white;
                            }
                        }
                    }
                }

                &__form {
                    &--container {
                        background-color: $subdomain-deep;
                    }
                }
            }
        }
    }
</style>
